/* @flow weak */
/* eslint react/prop-types: 0 */

class Validator {

  constructor() {

  }

  static errorMessages = {
    required: "This field is required.",
    number: "Numbers only.",
    email: "Please enter a valid email.",
    year: "Please enter a valid year.",
    day: "Please enter a valid day for this month.",
    url: "Please enter a valid url."
  };

  static findRequired(error) {
    return error?.type === "required";
  }

  static validate(value, rules, month) {
    let results = [];

    let required = rules.find(this.findRequired);
    if (required && !value) {
      let inValid = Validator.createError(required, Validator.errorMessages[required?.type]);
      results.push(inValid);
      return results;
    } else {
      for (let i = 0; i < rules.length; i++) {
        let inValid = {},
          type = rules[i]?.type.toLowerCase()
          ;
        switch (type) {
          case "email" :
            if (!Validator.valideEmail(value)) {
              inValid = Validator.createError(rules[i], Validator.errorMessages[type]);
              results.push(inValid);
            }
            break;
          case "number" :
            if (!Validator.isNumeric(value)) {
              inValid = Validator.createError(rules[i], Validator.errorMessages[type]);
              results.push(inValid);
            }
            break;
          case "year" :
            if (!Validator.validateYear(value)) {
              inValid = Validator.createError(rules[i], Validator.errorMessages[type]);
              results.push(inValid);
            }
            break;
          case "day" :
            if (!Validator.validateDay(value, month)) {
              inValid = Validator.createError(rules[i], Validator.errorMessages[type]);
              results.push(inValid);
            }
            break;
          case "url" :
                if (value && !Validator.validateURL(value)) {
                    inValid = Validator.createError(rules[i], Validator.errorMessages[type]);
                    results.push(inValid);
                }

          break;
        }
      }
    }

    return results;

  }
   static validateURL(textval) {

        var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
        return urlregex.test(textval);

}

  static createError(rule, errorMsg) {

    let error = {};
    error.name = rule?.type;
    error.valid = false;
    error.msg = rule.msg ? rule.msg : errorMsg;
    return error;
  }

  static valideEmail(email) {
    if(email) {
      let trimEmail = email.trim();

      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(trimEmail);
    }else{
      return false;
    }
  }

  static validateYear(year) {
    return year.toString().length == 4;
  }

  static validateDay(day, month) {

    if(month.indexOf('-') > -1){
       month = month.substr(3, 3);
    }

    if(month == 'Jan' || month == 'Mar' || month == 'Jul' || month == 'Aug' || month == 'Oct' || month == 'Dec'  || month == 'May') {
      return day < 32
    } else if(month == 'Apr' || month == 'Jun' || month == 'Sep' || month == 'Nov') {
      return day < 31
    } else if(month == 'Feb') {
      return day < 30
    }
  }

  static isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);

  }

}

export default Validator;
